import React, { useRef, useCallback, useMemo } from 'react';

import { SideNavBody } from '@atlaskit/navigation-system/layout/side-nav';

import { SideNavigationContext } from '@confluence/page-layout-side-navigation-context/entry-points/SideNavigationContext.ts';

import { fg } from '@confluence/feature-gating';

export const SideNavigationContent = ({ children }: { children: any }): React.JSX.Element => {
	const sideNavRef = useRef<HTMLDivElement>(null);

	const handleScrollToTop = useCallback(() => {
		if (sideNavRef.current) {
			sideNavRef.current.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}
	}, [sideNavRef]);

	const contextValue = useMemo(
		() => ({ sideNavRef, handleScrollToTop }),
		[sideNavRef, handleScrollToTop],
	);

	return (
		<SideNavigationContext.Provider value={contextValue}>
			{/* oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates */}
			{fg('navx-global-side-nav-confluence') ? (
				React.cloneElement(children, { sideNavContentRef: sideNavRef })
			) : (
				<SideNavBody testId="side-navigation-content" ref={sideNavRef}>
					{children}
				</SideNavBody>
			)}
		</SideNavigationContext.Provider>
	);
};
